import React, { useState } from 'react'
import { Formik, Field, Form } from 'formik';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const OTPForm = ({ user, resendCode, setVerified, showInfo, product }) => {

    const [requestCount, setRequestCount] = useState(0);
    const history = useHistory();

    return (
        <Formik
            initialValues={{
                pin: '',
            }}
            validate={values => {
                const errors = {};
                if (!values.code) {
                    errors.code = 'Code is Required';
                } else if (values.code.length !== 6) {
                    errors.code = 'Code is 6 digits long.';
                }

                return errors;
            }}
            onSubmit={async (values, { setSubmitting, setErrors }) => {

                setSubmitting(true);
                const headers = { 'Authorization': user.api_key }
                const res = await axios.post('https://evalexpert.io/v1/twoFactorCheck', { code: values.code, product }, { headers: headers })
                const data = res.data;
                setSubmitting(false);

                if (data.success) {
                    // using this function to send the code to the phone, then show the phone otp form
                    resendCode('phone');
                    // set the email as verified
                    setVerified('email');
                    history.push("/insightsdashboard/pages/dashboard/otp/phone");
                } else {
                    setErrors({code: 'Incorrect code'})
                }

            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
            }) => (
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        {user && <p className="block text-gray-600 mb-4 text-center">We have sent a code to <span className="font-medium">{user.email}</span></p>}
                        
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                            Your Code
                        </label>
                        <div className="mt-1">
                            <input
                                id="code"
                                name="code"
                                type="code"
                                placeholder="123456"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.code}
                                autoComplete="name"
                                className={
                                    errors.code && touched.code ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                        : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                }
                            />
                            <p className="mt-1 text-sm text-red-600" id="email-error">
                                {errors.code && touched.code && errors.code}
                            </p>
                        </div>
                    </div>
                    <div>
                        <button
                            type="submit"
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                            disabled={isSubmitting}
                        >
                            Validate
                        </button>
                        
                        {requestCount < 2 ? 
                            <p className="mt-2 text-sm text-gray-700">
                                Didn't receive a code? <p className="cursor-pointer text-sm text-gray-800 inline font-medium" onClick={() => {setRequestCount(requestCount + 1); resendCode('email'); showInfo('Code resent');}}>Request Again</p>
                            </p>
                            :
                            <p className="mt-2 text-sm text-gray-700">
                                Please contact <p className="cursor-pointer text-sm text-gray-800 inline font-medium" onClick={() => {window.location.href = 'mailto:support@algodriven.xyz'}}>support@algodriven.xyz</p> if no email received.
                            </p>
                        }
                    </div>
                </form>
            )}
        </Formik>
    )
}

export default OTPForm;
